import React from 'react';

const CRMContext = React.createContext({
    crmEnabled: false,
    crmChecked: false,
    crmChecking: false,
    setCRMChecking: () => { },
    setCRMAvailability: () => { },
    clearCRMAvailability: () => { }
});

export class CRMProvider extends React.Component {
    state = {
        crmEnabled: false,
        crmChecked: false,
        crmChecking: false
    };

    setCRMChecking = () => {
        this.setState({
            crmChecking: true
        });
    };

    setCRMAvailability = (enabled) => {
        this.setState({
            crmEnabled: !!enabled,
            crmChecked: true,
            crmChecking: false
        });
    };

    clearCRMAvailability = () => {
        this.setState({
            crmEnabled: false,
            crmChecked: false,
            crmChecking: false
        });
    };

    render() {
        const value = {
            ...this.state,
            setCRMChecking: this.setCRMChecking,
            setCRMAvailability: this.setCRMAvailability,
            clearCRMAvailability: this.clearCRMAvailability
        };

        return (
            <CRMContext.Provider value={value}>
                {this.props.children}
            </CRMContext.Provider>
        );
    }
}

export default CRMContext;
